import classNames from 'classnames';
import React from 'react';

type Props = {
  alignRight?: boolean,
  children?: React.ReactNode
};

class NavigationBarLayout extends React.Component<Props> {
  override render (): React.ReactNode {
    const { alignRight, children } = this.props;

    const navigationBarLayoutClassNames = classNames(
      'esko_nav',
      'esko_navbar-nav',
      {'esko_navbar-right': alignRight}
    );

    return (
      <ul className={navigationBarLayoutClassNames}>
        {children}
      </ul>
    );
  }
}

export default NavigationBarLayout;
